import React, {Fragment} from "react";
import Select from "../../../../form/Select";
import classNames from "classnames";
import AddressControl from "../../../../form/AddressControl";
import Barcoder from "../../../../../utils/barcoder";
import {AgentSelect, BarcodeFormatter, CurrencyFormatter} from "../../../../../utils/formatters";
import TextInput from "../../../../form/TextInput";
import ComponentConfig from "../../../../form/ComponentConfig";

const validator = new Barcoder('ean13');

class MemberCardComponent extends React.Component {

    render() {
        const {props} = this.props;
        const {hidden, labels} = props;
        const agent = props.getValue("agent");
        const membercard = props.getValue("membercard");
        return (hidden || []).indexOf("agent") === -1 && <div className="row">
            <div className={classNames({
                "col-md-3": agent,
                "col-md-12": !agent
            })}>
                {!agent && membercard ?
                    <TextInput
                        label={labels.customer || "Vevőkártya"}
                        name="membercard"
                        type="number"
                        value={membercard}
                        className={(!agent ? membercard && !isNaN(membercard) && (!validator.validate(membercard) || /^0*$/.test(membercard)) : false) ? "is-invalid" : (validator.validate(membercard) ? "is-valid" : "is-invalid")}
                        saveChanges={props.setFieldValue}
                    />
                    :
                    <Select
                        label={labels.customer || "Vevő"}
                        name="agent"
                        component="user"
                        isClearable={true}
                        objectValue={true}
                        optionsTemplate={AgentSelect}
                        labelKey="name"
                        searchtype="member"
                        {...props.getProps("agent")}
                        storeType="remote"
                        value={agent}
                        searchFormatter={(input) => {
                            input = BarcodeFormatter(input);
                            if (!isNaN(input)) {
                                input = input + '';
                                while (input.length < 13)
                                    input = '0' + input;
                            }
                            return input;
                        }}
                        className={(!agent ? membercard && !isNaN(membercard) && (!validator.validate(membercard) || /^0*$/.test(membercard)) : false) ? "is-invalid" : (membercard ? "is-valid" : "")}
                        saveChanges={(field, agent) => {
                            props.setFormValues({...props.values, agent, membercard: null});
                        }}
                        autoSelect={true}
                        onLoadCompleted={(options, barcode) => {
                            if (options.length === 0) {
                                if (barcode.length === 12) {
                                    barcode = "0" + barcode;
                                }
                                if (validator.validate(barcode)) {
                                    props.setFormValues({...props.values, agent: null, membercard: barcode});
                                } else {
                                    props.setFormValues({...props.values, agent: null, membercard: null});
                                }
                            }
                        }}
                    />}
            </div>
            {agent && <Fragment>
                <div className={classNames({"col-md-9": !this.props.userConfig.fielddefs.purchasetotal, "col-md-7": !!this.props.userConfig.fielddefs.purchasetotal})}>
                    <div className={"row"}>
                        <AddressControl
                            disabled={"disabled"}
                            value={agent.address}
                            label="Cím"
                        />
                    </div>
                </div>
                <div className="col-md-2 currency">
                    <TextInput
                        value={agent.purchasetotal}
                        formatter={CurrencyFormatter}
                        disabled={true}
                        label="Összes vásárlása"
                    />
                </div>
            </Fragment>}
        </div>;
    }
}

const MemberCard = (props) => {
    return <ComponentConfig componentName="user" componentConfigAs="userConfig">
        <MemberCardComponent {...props} />
    </ComponentConfig>
}

export default MemberCard;